import {
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    Button
} from '@mui/material';
import { Body1 } from '../../themes/typography';

export default function DeleteDialog({
    open = false,
    loader = false,
    onClose = () => {},
    onDeleteConfirm = () => {},
    dialogTitle = 'Are you sure want to delete ticket?',
    dialogDescription = 'This action cannot be undone. Please confirm if you want to proceed with the deletion.',
    primaryButtonText = 'Delete',
    secondaryButtonText = 'Cancel',
    shouldDisabledBtns = false
}) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={dialogStyle}
        >
            <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <Body1>{dialogDescription}</Body1>
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={dialogActionsStyle}>
                <Button
                    variant="text"
                    onClick={onClose}
                    sx={dialogActionsMainBtn}
                    disabled={shouldDisabledBtns}
                >
                    {secondaryButtonText}
                </Button>
                <Button
                    variant="delete"
                    onClick={onDeleteConfirm}
                    sx={dialogActionsMainBtn}
                    disabled={loader || shouldDisabledBtns}
                    endIcon={
                        loader ? (
                            <CircularProgress size={20} sx={{ color: 'var(--quaternary-color)' }} />
                        ) : null
                    }
                >
                    {primaryButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const dialogStyle = {
    '& .MuiPaper-root': {
        background: 'linear-gradient(to top left, #0A1528, #1D3A6E)',
        color: '#f5f5f5',
        borderRadius: '1rem',
        border: '1px solid #CCCCCC',
        minWidth: '600px',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem'
    }
};

const dialogActionsStyle = {
    padding: '1.25rem 1.5rem 1.5rem 1.5rem',
    gap: '0.5rem'
};

const dialogActionsMainBtn = {
    paddingTop: '6px',
    paddingBottom: '6px',
    fontSize: '1.125rem'
};
